import React from 'react';
import {
    bundledLanguages,
    createdBundledHighlighter,
    createJavaScriptRegexEngine,
    createSingletonShorthands,
    type Highlighter,
} from 'shiki';

import { DEFAULT_SYNTAX } from './syntaxes';
import { theme } from './theme';

const { getSingletonHighlighter } = createSingletonShorthands(
    createdBundledHighlighter<any, any>({
        langs: bundledLanguages,
        themes: {
            light: theme,
            dark: theme,
        },
        engine: () => createJavaScriptRegexEngine({ forgiving: true, target: 'ES2018' }),
    })
);

export function useSyntaxHighlighter() {
    const [highlighter, setHighlighter] = React.useState<Highlighter | null>(null);
    React.useEffect(() => {
        (async () => {
            const result = await getHighlighter();
            setHighlighter(result);
        })();
    }, []);
    return highlighter;
}

export async function getHighlighter() {
    return await getSingletonHighlighter({
        langs: [DEFAULT_SYNTAX],
        themes: [theme],
    });
}
